import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
  Renderer2,
  ViewEncapsulation,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DateTime, Zone } from 'luxon';
import { GeneralService } from '../../../../services/general/general.service';
import { Router, ActivatedRoute } from '@angular/router';
import { InfoDialogComponent } from 'src/app/components/info-dialog/info-dialog.component';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['../../../../../shared-styles/dashboard.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class IndexComponent implements OnInit {
  public isMobile: any;
  public headerHeight: any = 0;
  public loading: any = false;
  public subscriptions: any = [];
  public nextClass: any = null;
  public nextClassButton = false;
  public rating = 0;
  public activeStudents = 0;
  public refered_code: any = null;
  public video_presentation: any = null;
  public socialNetworks: any = {
    twitter: '',
    facebook: '',
    instagram: '',
    linkedin: '',
  };
  
  public hasSocialNetworks = false;
  public socialMediaForm: FormGroup;

  public user: any;
  public userInfo: any;
  public buySubSuccess = false;

  public hide_perfil: any;
  public hide_admin_perfil: any;

  nextClassStart: any;
  nextClassEnd: any;
  currentLocale: string | null;

  constructor(
    public general: GeneralService,
    private cdRef: ChangeDetectorRef,
    private renderer: Renderer2,
    private formBuilder: FormBuilder,
    private _router: Router,
    private _route: ActivatedRoute,
    public dialog: MatDialog
  ) {
    this.socialMediaForm = this.formBuilder.group({
      twitter: '',
      facebook: '',
      instagram: '',
      linkedin: '',
    });

    this.isMobile = this.general.isMobile();

    this._route.queryParams.subscribe(async (params) => {
      if (!params.buy_sub_success) {
        return;
      }
    });

    this.currentLocale = this.general.getCurrentLocale();
  }

  async ngOnInit() {
    try {
      this.general.setLoading(true);
      this.intializeSubscriptions();
      await this.getUserInfo();
      await this.getInitialData();
      this.checkTimeToClass();
    } catch (error) {
      console.log(error);
    } finally {
      this.general.setLoading(false);
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription: any) => {
      subscription.unsubscribe();
    });
  }

  intializeSubscriptions() {
    this.subscriptions = [
      this.general.loading$.subscribe((res) => (this.loading = res)),
    ];
  }

  async getUserInfo() {
    const response = await this.general.getUserInfo();
    this.userInfo = response.data;
    this.user = this.userInfo.user;
  }

  async getInitialData() {
    const request = [
      this.general.httpGet('next-class'),
      this.general.httpGet('teacher-dashboard'),
    ];

    const responses: any = await this.general.forkJoin(request);
    this.nextClass = responses[0];

    this.rating = responses[1].data.total_puntuation;
    this.activeStudents = responses[1].data.total_students;
    this.refered_code = responses[1].data.refered_code;
    this.video_presentation = responses[1].data.video_presentation;
    this.hide_perfil = responses[1].data.is_hidden;
    this.hide_admin_perfil = responses[1].data.is_admin_hidden;

    await this.patchFormSocialMedia(responses[1]?.data.social_networks[0]);

    if (!this.nextClass) {
      return;
    }

    const timezone = this.general.getCurrentTimezone();

    this.nextClass.start = DateTime.fromFormat(
      this.nextClass.start,
      'yyyy-LL-dd HH:mm:ss',
      {
        zone: 'UTC+1',
      }
    ).setZone(timezone);
    this.nextClassStart = this.nextClass.start
      .setLocale(this.currentLocale)
      .toFormat('d MMM yy H:mm');

    this.nextClass.end = DateTime.fromFormat(
      this.nextClass.end,
      'yyyy-LL-dd HH:mm:ss',
      {
        zone: 'UTC+1',
      }
    ).setZone(timezone);
    this.nextClassEnd = this.nextClass.end
      .setLocale(this.currentLocale)
      .toFormat('d MMM yy H:mm');
  }

  checkTimeToClass() {
    if (!this.nextClass) {
      return;
    }

    const timezone = this.general.getCurrentTimezone();

    const now = DateTime.local().setZone(timezone);

    const start = this.nextClass.start;
    const end = this.nextClass.end;

    //this.nextClassButton = now.toMillis() + 1000 * 60 * 60 * 2 > end.toMillis();
    this.nextClassButton = start.toMillis() < end.toMillis();
  }

  async updateSocialMedia() {
    try {
      const response = await this.general.httpPost(
        'teacher-socialnetworks',
        this.socialMediaForm.value
      );

      await this.patchSocialNetworks(response.data);
      await this.general.showSuccess('social-media-updated');

    } catch (error) {
      await this.general.showDanger('social-media-not-updated');
    }
  }


  async hidePerfil(hide:any) {

    await this.general.httpPost('teacher-visibility', {
      visibility: hide,
    });
      this.hide_perfil = hide;
  }

  async generatePremiumLink() {
    if (this.refered_code) {
      navigator.clipboard.writeText(this.refered_code);
      await this.general.showSuccess('url-copied-clipboard');
    } else {
      this.general.navigate('premium');
    }
  }

  async onSelectFile(event: any) {
    try {
      if (event.files.item(0)) {
        const photo = event.files.item(0);
        const formData: any = new FormData();
        formData.append('profile_photo_path', photo);
        const response = await this.general.httpPost('update-photo', formData);
        if(response){
          const $source: any = document.getElementById('dashboard-photo');
          $source.setAttribute('src', URL.createObjectURL(photo));
        }
      }
 
    } catch (error) {
      await this.general.showDanger('photo_error_upload');
    }
  }

  showInfo(buyResult: any) {
    let data = {
      imgSrc: '',
      title: '',
      message: '',
    };
    if (buyResult) {
      data = {
        imgSrc: 'assets/img/premium-crown.png',
        title: 'premium-success-title',
        message: 'premium-success-message',
      };
    } else {
      data = {
        imgSrc: 'assets/img/warning.png',
        title: 'premium-failure-title',
        message: 'premium-failure-message',
      };
    }
    this.dialog.open(InfoDialogComponent, {
      disableClose: true,
      data,
    });
  }

  openSocialNetwork(
    socialNetwork: 'linkedin' | 'twitter' | 'facebook' | 'instagram'
  ) {
    if (!this.socialNetworks[socialNetwork]) {
      return;
    }
    window.open(this.socialNetworks[socialNetwork], '_blank');
  }

  async patchFormSocialMedia(data: any) {
    await this.patchSocialNetworks(data);
    this.socialMediaForm.patchValue({
      twitter: this.socialNetworks.twitter
        ? this.socialNetworks.twitter.split('https://twitter.com/')[1]
        : null,
      facebook: this.socialNetworks.facebook
        ? this.socialNetworks.facebook.split('https://facebook.com/')[1]
        : null,
      instagram: this.socialNetworks.instagram
        ? this.socialNetworks.instagram.split('https://instagram.com/')[1]
        : null,
      linkedin: this.socialNetworks.linkedin
        ? this.socialNetworks.linkedin.split('https://linkedin.com/')[1]
        : null,
    });
  }

  async patchSocialNetworks(data: any) {
    this.hasSocialNetworks =
      data?.tw_url || data?.fb_url || data?.ig_url || data?.li_url;

    this.socialNetworks = {
      twitter: data?.tw_url,
      facebook: data?.fb_url,
      instagram: data?.ig_url,
      linkedin: data?.li_url,
    };
  }

}
